import { motion } from 'framer-motion';
import { AnimatedSection } from './AnimatedSection';
import { usePublicConfig } from '../context';

export const CTA = () => {
  const { config: publicConfig } = usePublicConfig();
  const chamaName = publicConfig?.name ?? 'LoopFund';

  return (
  <AnimatedSection className="section-padding" delay={0.15}>
    <div className="mx-auto flex max-w-5xl flex-col items-center gap-6 rounded-4xl bg-brand-600 px-6 py-16 text-center text-white transition-colors duration-300 md:px-12 lg:px-20 dark:bg-brand-500">
      <motion.h2
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        viewport={{ once: true }}
        className="font-display text-3xl leading-tight md:text-4xl"
      >
        Ready to transform your chama?
      </motion.h2>
      <p className="max-w-2xl text-base text-white/80">
        Stop the WhatsApp madness. Get automated contributions, transparent tracking, and happy members. 
        See the {chamaName} demo, then let's set up yours.
      </p>
      <div className="flex flex-col gap-3 sm:flex-row">
        <a
          href="tel:+254743269238"
          className="inline-flex items-center justify-center rounded-full bg-white px-7 py-3 text-sm font-semibold text-brand-600 transition hover:bg-slate-100"
        >
          📞 Call us: 0743 269 238
        </a>
        <a
          href="mailto:info@gritagencies.co.ke"
          className="inline-flex items-center justify-center rounded-full border border-white px-7 py-3 text-sm font-semibold text-white transition hover:bg-brand-700"
        >
          ✉️ info@gritagencies.co.ke
        </a>
      </div>
      <p className="mt-2 text-sm text-white/60">
        Get your chama running in 48 hours. Demo available 24/7.
      </p>
    </div>
  </AnimatedSection>
  );
};
